// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_g0-6";
export var emphasizeQuantity = "_g0-3";
export var flatBottomCorners = "_g0-5";
export var productImage = "_g0-0";
export var quantityContainer = "_g0-2";
export var tooltip = "_g0-1";
export var wrapAndEllipsesOverflow = "_g0-4";